module.exports = __webpack_public_path__ + "images/drop_down_arrow.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/drop_down_arrow.svg
// module id = 1130
// module chunks = 0